/*
 * Copyright (C) 2018 - present by OpenGamma Inc. and the OpenGamma group of companies
 *
 * Please see distribution for license.
 */

import { NgModule } from '@angular/core';
import { AuthGuard } from './auth.guard';
import { RouterModule, Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/tenants'
  },
  {
    path: 'tenants/calcs',
    pathMatch: 'prefix',
    loadChildren: () => import('app/page-modules/jobs/module').then(m => m.JobsModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'tenants/metrics',
    pathMatch: 'prefix',
    loadChildren: () => import('app/page-modules/metrics/module').then(m => m.MetricsModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'tenants/portfolio-conversion',
    pathMatch: 'prefix',
    loadChildren: () =>
      import('app/page-modules/portfolio-conversion/module').then(m => m.ConvertPortfolioModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'tenants/ini-script',
    pathMatch: 'prefix',
    loadChildren: () => import('app/page-modules/ini-script/module').then(m => m.IniScriptModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'tenants/reports',
    pathMatch: 'prefix',
    loadChildren: () => import('app/page-modules/reports/module').then(m => m.ReportsModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'tenants/config',
    pathMatch: 'prefix',
    loadChildren: () => import('app/page-modules/config/module').then(m => m.ConfigModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'tenants',
    pathMatch: 'prefix',
    loadChildren: () =>
      import('app/page-modules/tenant-management/module').then(m => m.TenantManagementModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'data',
    pathMatch: 'prefix',
    loadChildren: () =>
      import('app/page-modules/data-management/module').then(m => m.DataManagementModule),
    canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  providers: [AuthGuard],
  exports: [RouterModule]
})
export class AppRoutingModule {}
